import React, { useRef } from 'react';
import { Menu } from '../../../menu';
import { List } from '../../../list';
import { ListItem } from '../../../list-item';
import { ListItemContent } from '../../../list-item-content';
import { Icon } from '../../../icon';
import { CheckedIcon, HeaderButton, MenuContent } from './styled';
import { useDropdown } from './utils/use-dropdown';
const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
const listItemContentStyles = { marginRight: 8 };
export const MonthsDropdown = ({ children, changeMonth, calendarRef, monthDate }) => {
    const menuRef = useRef(null);
    const { isOpen, handleToggle, handleClose } = useDropdown({
        id: 'months-dropdown',
        /* @ts-ignore */
        // Wrap into useRef to prevent undefined return value if calendarRef.current is undefined
        calendarInstance: useRef(calendarRef === null || calendarRef === void 0 ? void 0 : calendarRef.current),
        menuRef
    });
    return (React.createElement(Menu, { listComponent: List, isOpen: isOpen, onClickOutside: handleClose, content: React.createElement(MenuContent, { ref: menuRef }, months.map((month, index) => {
            const isCurrentMonth = monthDate.getMonth() === index;
            return (React.createElement(ListItem, { selected: isCurrentMonth, key: month, button: true, onClick: () => changeMonth(index) },
                React.createElement(ListItemContent, { component: "span", style: listItemContentStyles }, month),
                isCurrentMonth ? React.createElement(CheckedIcon, null) : null));
        })) },
        React.createElement(HeaderButton, { text: children, onClick: handleToggle, EndIcon: React.createElement(Icon, { name: "arrow_down" }) })));
};
